import classnames from 'classnames'
import React from 'react'
import styles from './title.module.scss'
import { TitleProps } from './title.types'

export const Title: React.FC<TitleProps> = ({ className, children }) => (
  <p className={classnames(className, styles.title)}>{children}</p>
)
